import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'container', 'leftRegion', 'rightRegion']);

/**
 * AwardBlock theme – 50/50 layout styling (same as Section Panel variant 50/50).
 *
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "container" | "leftRegion" | "rightRegion")[]
 * }>} AwardBlockStyles
 */
export const awardBlockStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.AwardBlock} args.component - AwardBlock component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {AwardBlockStyles} - Component styles
   */
  baseStyle() {
    return {
      root: {},
      container: {
        maxWidth: '1440px',
        marginX: 'auto',
        paddingTop: {base: 14, md: 20},
        paddingBottom: {base: 14, md: 30},
        paddingLeft: {base: 5, md: 20},
        paddingRight: {base: 5, md: 20},
        flexDirection: {base: 'column', md: 'row'},
        alignItems: {base: 'stretch', md: 'center'},
        gap: 10,
        sx: {
          '.amb-markup p': {
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: {base: 'md', md: 'lg'},
            lineHeight: {base: '150%', md: '160%'},
            marginBottom: 0,
          },
          '.amb-markup h2': {
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: {base: '2.75xl', md: '4.75xl'},
            lineHeight: '120%',
            color: 'brandColors.greyscale90',
            letterSpacing: {base: 'headingTight', md: 'headingTighter'},
          },
          '.component--action-links a p': {
            fontSize: 'sm',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '120%',
          },
          '.amb-markup a p': {
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: 'sm',
            lineHeight: '120%',
          },
        },
      },
      leftRegion: {
        flex: {base: '1', md: '1'},
      },
      rightRegion: {
        flex: {base: '1', md: '1'},
      },
    };
  },
});
